import '../../styles/Auth.css';

import {faEye, faEyeSlash} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';

import {apiService} from '../../apiService';
import {useAuth} from '../../contexts/AuthContext';

const Login = () => {
  const [lastName, setLastName] = useState('');
  const [employeePin, setEmployeePin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPin, setShowPin] = useState(false);
  const navigate = useNavigate();
  const {login} = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await apiService.post('/api/verify-employee-login/', {
        last_name: lastName.toLowerCase().trim(),
        employee_pin: employeePin,
      });

      if (data && data.valid) {
        // Save user data
        login(data.employee_data);

        navigate('/dashboard');
      } else {
        // Login failed
        setError('Invalid employee last name');
      }
    } catch (error) {
      setError('An error occurred during login. Please try again.');
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  const togglePinVisibility = () => {
    setShowPin(!showPin);
  };

  return (
    <div className='auth-container'>
      <div className='auth-card'>
        <h2>Welcome to Tenvos</h2>

        {error && <div className='auth-error'>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className='form-group'>
            <label htmlFor='lastName'>Last Name</label>
            <input
              type='text'
              id='lastName'
              placeholder='Enter your last name'
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
              disabled={loading}
              autoComplete='family-name'
            />
          </div>

          <div className='form-group'>
            <label htmlFor='employeePin'>Employee PIN</label>
            <div className='password-input-container'>
              <input
                type={showPin ? 'text' : 'password'}
                id='employeePin'
                placeholder='Enter your employee PIN'
                value={employeePin}
                onChange={(e) => setEmployeePin(e.target.value)}
                required
                disabled={loading}
                inputMode='numeric'
                pattern='[0-9]*'
                autoComplete='off'
              />
              <button
                type='button'
                className='password-toggle-btn'
                onClick={togglePinVisibility}
                tabIndex='-1'
                aria-label={showPin ? 'Hide PIN' : 'Show PIN'}
              >
                <FontAwesomeIcon icon={showPin ? faEyeSlash : faEye} />
              </button>
            </div>
          </div>

          <button type='submit' className='auth-button' disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div className='auth-links'>
          {/* <Link to="/forgot-password" className="auth-link">Forgot password?</Link>
          <Link to="/signup" className="auth-link">Need an account? Sign up</Link>
          <Link to="/privacy" className="auth-link">Privacy</Link> */}
        </div>
      </div>
    </div>
  );
};

export default Login;
